import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { SharedUiCardsModule } from '@shared/ui/cards';
import { SharedUiBadgesModule } from '@shared/ui/badges';

@NgModule({
  imports: [CommonModule, RouterModule, SharedUiCardsModule, SharedUiBadgesModule],
  declarations: [HeaderComponent, FooterComponent],
  exports: [HeaderComponent, FooterComponent],
})
export class SharedUiPageToolbarsModule {}
